import { cn } from '@/lib/cn';

/**
 * Status TIDAK boleh dibedakan warna saja — selalu ada penanda bentuk (●/◐/✓/○)
 * plus teks, supaya terbaca oleh pengguna dengan gangguan penglihatan warna.
 */

type Tone = 'neutral' | 'info' | 'success' | 'warn' | 'danger';

const TONES: Record<Tone, string> = {
  neutral: 'bg-app text-ink-secondary',
  info: 'bg-primary-soft text-primary',
  success: 'bg-success-soft text-success',
  warn: 'bg-warn-soft text-[#9a6400]',
  danger: 'bg-danger-soft text-danger',
};

const PRESETS: Record<string, { label: string; tone: Tone; mark: string }> = {
  // Penilaian
  draft: { label: 'Draft', tone: 'neutral', mark: '◐' },
  submitted: { label: 'Diajukan', tone: 'info', mark: '●' },
  verified: { label: 'Diverifikasi', tone: 'success', mark: '✓' },
  returned: { label: 'Dikembalikan', tone: 'warn', mark: '↩' },
  // Risalah monev
  open: { label: 'Open', tone: 'danger', mark: '●' },
  in_progress: { label: 'In-Progress', tone: 'warn', mark: '◐' },
  resolved: { label: 'Resolved', tone: 'success', mark: '✓' },
  // Entitas profil
  active: { label: 'Aktif', tone: 'success', mark: '●' },
  inactive: { label: 'Nonaktif', tone: 'neutral', mark: '○' },
  graduated: { label: 'Lulus', tone: 'info', mark: '★' },
  alumni: { label: 'Alumni', tone: 'neutral', mark: '○' },
  // Periode
  upcoming: { label: 'Akan datang', tone: 'neutral', mark: '○' },
  locked: { label: 'Terkunci', tone: 'neutral', mark: '🔒' },
};

interface Props {
  status: string;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: Props) {
  const preset = PRESETS[status] ?? { label: status, tone: 'neutral' as Tone, mark: '•' };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[13px] font-medium',
        TONES[preset.tone],
        className,
      )}
    >
      <span aria-hidden>{preset.mark}</span>
      {label ?? preset.label}
    </span>
  );
}
